import { Box } from "@mui/system"
import { ElementType } from "react"
import ListTitle from "../ListTitle"
import Search from "../Search"
import { IconButton, Tooltip } from "@mui/material"
import { Add, Forum } from "@mui/icons-material"

interface ConversationsHeaderProps {
    setStarting: (starting: boolean) => void;
}

const ConversationsHeader: ElementType<ConversationsHeaderProps> = 
({ setStarting }) => {
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            mb: 3
        }}>
            <ListTitle title="Conversations" icon={Forum} />
            <Search placeholder="Search conversations..." />
            <Box sx={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'flex-end',
            }}>
                <Tooltip title="Start a new conversation" arrow>
                    <IconButton
                        color="primary"
                        onClick={() => setStarting(true)}
                        sx={{
                            backgroundColor: 'primary.main',
                            color: 'white',
                            flexShrink: 0,
                            '&:hover': {
                                backgroundColor: 'primary.dark',
                            }
                        }}
                    >
                        <Add />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    )
}

export default ConversationsHeader